import React from 'react';
import { View, ViewStyle, StyleSheet, LayoutChangeEvent } from 'react-native';
import { Theme } from '../../utils/theme';

interface OnboardingPageContainerProps {
  children: React.ReactNode;
  style?: ViewStyle;
  maxWidth?: number;
  onLayout?: (width: number) => void;
}

/**
 * Container component for onboarding screens that:
 * - Centers content horizontally
 * - Applies max-width (default 500px) for web/desktop
 * - Maintains full width on mobile
 * - Background extends full width while content is constrained
 * - Provides consistent styling across all onboarding screens
 */
export const OnboardingPageContainer: React.FC<OnboardingPageContainerProps> = ({
  children,
  style,
  maxWidth = 500,
  onLayout,
}) => {
  const handleLayout = (event: LayoutChangeEvent) => {
    if (onLayout) {
      const { width } = event.nativeEvent.layout;
      onLayout(width);
    }
  };

  return (
    <View style={styles.outerContainer}>
      <View 
        style={[styles.innerContainer, { maxWidth }, style]}
        onLayout={handleLayout}
      >
        {children}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  outerContainer: {
    flex: 1,
    width: '100%',
    alignItems: 'center', // Center the inner container horizontally
    backgroundColor: Theme.colors.background,
  },
  innerContainer: {
    flex: 1,
    width: '100%', // Take full width up to maxWidth
  },
});

export default OnboardingPageContainer;

